module.exports = __webpack_public_path__ + "static/media/arrowUpBlue.891df973.svg";